import type { TableType } from "../Types/tabletype";
import { withCache } from "./apiCacheHelper.ts";
import apiClient from "./apiClient.ts";

export const getTable = async (id: string | number): Promise<TableType> => {
  const tableId = encodeURIComponent(String(id));

  return withCache(`table_${tableId}`, async () => {
    try {
      const res = await apiClient.get<TableType>(`/table/find/${tableId}`);
      return res.data;

    } catch (error) {
      console.error("Table API Error:", error);
      throw error;
    }
  });
};
